<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <ng-content></ng-content>
</form>
